import { render, staticRenderFns } from "./CompatibleWarning.vue?vue&type=template&id=4c6c5971&scoped=true&"
import script from "./CompatibleWarning.vue?vue&type=script&lang=js&"
export * from "./CompatibleWarning.vue?vue&type=script&lang=js&"
import style0 from "./CompatibleWarning.vue?vue&type=style&index=0&id=4c6c5971&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c5971",
  null
  
)

export default component.exports